import React from 'react';
import { Grid, Typography } from '@mui/material';

import EntityInfo from './shared/EntityInfo';
import CloseButton from './shared/CloseButton';

import { GridMainContainer, sxStyle } from '../styles';

const Assist = ({
  searchType,
  bookingDetails,
  useBookingColor,
  formatDate,
  hasEntity,
  getHref,
  history,
}) => {
  const id_status = bookingDetails?.status?.id;

  return (
    <GridMainContainer
      searchType={searchType}
      data-testid="bookingDetail_view_assist"
    >
      <Grid container direction="column" alignItems="center" sx={sxStyle.root}>
        <Grid item sx={sxStyle.gridPadding}>
          <Grid item container direction="column" alignItems="center">
            <Typography align="center" sx={sxStyle.bookingDetailTitle}>
              ¡Encontramos la reserva!
            </Typography>
            <Typography sx={sxStyle.bookingDetailSubtitle}>
              Código de localizador: {bookingDetails?.locator}
            </Typography>

            <Grid container sx={sxStyle.gridContainer}>
              <Grid
                item
                sx={{
                  ...sxStyle.status,
                  backgroundColor: useBookingColor(id_status),
                }}
              >
                Estado:{' '}
                {bookingDetails?.codes?.length > 0 ? 'Confirmada' : 'Fallo'}
              </Grid>

              <Grid item container sx={sxStyle.gridBookingDetail}>
                <Grid
                  item
                  xs={12}
                  sx={
                    hasEntity
                      ? sxStyle.gridItemBookingDetailHotel
                      : sxStyle.gridItemBookingDetailHotel
                  }
                >
                  <Typography sx={sxStyle.bookingDetailText}>
                    <Typography component="span" sx={{ fontWeight: 600 }}>
                      Asistencia al viajero
                    </Typography>
                  </Typography>

                  <Typography sx={sxStyle.bookingDetailText}>
                    Assist Card
                  </Typography>
                  <Typography sx={sxStyle.bookingDetailText}>
                    Destino: {bookingDetails?.destination}
                  </Typography>
                  {bookingDetails?.nombre && (
                    <Typography sx={sxStyle.bookingDetailText}>
                      Cobertura: {bookingDetails?.nombre}
                    </Typography>
                  )}
                  {bookingDetails.start_date && (
                    <Typography sx={sxStyle.bookingDetailText}>
                      Fecha de inicio de la cobertura:{' '}
                      {formatDate(bookingDetails?.start_date)}
                    </Typography>
                  )}
                  {bookingDetails.end_date && (
                    <Typography sx={sxStyle.bookingDetailText}>
                      Fecha de finalizacion de la cobertura:{' '}
                      {formatDate(bookingDetails?.end_date)}
                    </Typography>
                  )}
                </Grid>
                <EntityInfo
                  bookingDetails={bookingDetails}
                  getHref={getHref}
                  sxStyle={sxStyle}
                  hasEntity={hasEntity}
                />
              </Grid>
            </Grid>
            <CloseButton history={history} />
          </Grid>
        </Grid>
      </Grid>
    </GridMainContainer>
  );
};

export default Assist;
